export function ensureHttps(url) {
  if (!url) return '';

  if (url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }

  if (!url.startsWith('https://')) {
    return `https://${url}`;
  }

  return url.trim();
}
